import React from 'react';
import { Paperclip } from 'lucide-react';

export default function EmailItem({ email, isSelected, onClick }) {
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const now = new Date();
        const diffMs = now - date;
        const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

        if (diffDays === 0) {
            return date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });
        } else if (diffDays < 7) {
            return date.toLocaleDateString('en-US', { weekday: 'short' });
        }
        return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    };

    // Generate initials and color for avatar
    const initials = (email.from || '?').replace(/[^a-zA-Z ]/g, "").match(/\b\w/g || [])?.shift()?.toUpperCase() || '?';
    const avatarColor = `hsl(${(email.from?.length * 50) % 360}, 70%, 80%)`;

    return (
        <div
            onClick={onClick}
            className={`group px-4 py-4 cursor-pointer border-b border-gray-100 transition-all hover:bg-gray-50 ${isSelected ? 'bg-blue-50/60 border-l-[3px] border-l-blue-600' : 'border-l-[3px] border-l-transparent'
                }`}
        >
            <div className="flex gap-3">
                {/* Avatar */}
                <div
                    className="h-10 w-10 rounded-full flex items-center justify-center text-sm font-bold text-gray-700 shrink-0 shadow-sm"
                    style={{ backgroundColor: avatarColor }}
                >
                    {initials}
                </div>

                <div className="flex-1 min-w-0">
                    <div className="flex justify-between items-baseline mb-1">
                        <h4 className={`text-sm truncate ${isSelected ? 'font-bold text-blue-900' : 'font-semibold text-gray-900'}`}>
                            {email.from}
                        </h4>
                        <span className={`text-xs whitespace-nowrap ml-2 ${isSelected ? 'text-blue-700' : 'text-gray-500'}`}>
                            {formatDate(email.date)}
                        </span>
                    </div>

                    <h5 className={`text-sm truncate mb-1 ${isSelected ? 'font-medium text-gray-800' : 'text-gray-700'}`}>
                        {email.subject}
                    </h5>

                    <div className="flex items-center justify-between">
                        <p className="text-xs text-gray-500 truncate max-w-[90%]">
                            {email.text}
                        </p>
                        {email.hasAttachments && (
                            <Paperclip className="h-3 w-3 text-gray-400 shrink-0" />
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}